import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './SharedStyles.css';

const Register: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (password !== confirmPassword) {
      setError('Passwörter stimmen nicht überein');
      setLoading(false);
      return;
    }

    if (password.length < 8) {
      setError('Passwort muss mindestens 8 Zeichen lang sein');
      setLoading(false);
      return;
    }

    try {
      await register(email, password);
      navigate('/dashboard');
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-page">
      <header className="app-nav">
        <nav className="app-nav-content">
          <Link to="/" className="app-logo">
            Pfändungstabelle API
          </Link>
          <div className="app-nav-links">
            <Link to="/" className="app-nav-link">
              ← Zurück zur Startseite
            </Link>
          </div>
        </nav>
      </header>

      <main className="app-main">
        <div className="app-container-form">
          <div className="text-center mb-6">
            <h1 className="app-title">Neues Konto erstellen</h1>
          </div>

          <form className="app-form" onSubmit={handleSubmit}>
            {error && (
              <div className="app-alert app-alert-error">
                {error}
              </div>
            )}

            <div className="app-form-group">
              <label htmlFor="email" className="app-label">
                E-Mail-Adresse
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="app-input"
                placeholder="ihre@email.de"
              />
            </div>

            <div className="app-form-group">
              <label htmlFor="password" className="app-label">
                Passwort
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="new-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="app-input"
                placeholder="Mindestens 8 Zeichen"
              />
              <p className="mt-2" style={{ fontSize: '0.875rem', color: 'var(--text-light)' }}>
                Mindestens 8 Zeichen
              </p>
            </div>

            <div className="app-form-group">
              <label htmlFor="confirmPassword" className="app-label">
                Passwort bestätigen
              </label>
              <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                autoComplete="new-password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="app-input"
                placeholder="Passwort wiederholen"
              />
            </div>

            <div className="flex items-center mb-6">
              <input
                id="terms"
                name="terms"
                type="checkbox"
                required
                className="app-checkbox"
              />
              <label htmlFor="terms" style={{ color: 'var(--text-dark)', fontSize: '0.875rem' }}>
                Ich akzeptiere die{' '}
                <Link to="/terms" style={{ color: 'var(--accent-blue)', textDecoration: 'none' }}>
                  Allgemeinen Geschäftsbedingungen
                </Link>{' '}
                und die{' '}
                <Link to="/privacy" style={{ color: 'var(--accent-blue)', textDecoration: 'none' }}>
                  Datenschutzerklärung
                </Link>
              </label>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="app-button app-button-primary app-button-full"
            >
              {loading ? (
                <>
                  <span className="app-loading"></span>
                  <span style={{ marginLeft: '0.5rem' }}>Konto wird erstellt...</span>
                </>
              ) : (
                'Konto erstellen'
              )}
            </button>

            <div style={{ margin: '2rem 0', textAlign: 'center', position: 'relative' }}>
              <div style={{ 
                position: 'absolute', 
                top: '50%', 
                left: 0, 
                right: 0, 
                height: '1px', 
                background: 'var(--border-light)' 
              }}></div>
              <span style={{ 
                background: 'var(--background-white)', 
                padding: '0 1rem', 
                color: 'var(--text-light)',
                position: 'relative'
              }}>
                Oder
              </span>
            </div>
            <Link to="/login" className="app-button app-button-secondary app-button-full">
              Melden Sie sich bei Ihrem bestehenden Konto an
            </Link>

            <div className="app-alert app-alert-info" style={{ marginTop: '2rem' }}>
              <div className="flex items-center">
                <svg style={{ width: '1.25rem', height: '1.25rem', marginRight: '0.75rem', flexShrink: 0 }} viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
                <div>
                  <h3 style={{ fontWeight: '600', marginBottom: '0.5rem' }}>
                    Kostenlose Registrierung
                  </h3>
                  <p style={{ margin: 0, fontSize: '0.875rem' }}>
                    Nach der Registrierung erhalten Sie sofort Zugang zu Ihrem Dashboard. 
                    Sie können dann einen Tarif auswählen und sofort mit der API-Nutzung beginnen.
                  </p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Register;
